<template lang="pug">
    
    MDashboardWidget( title="Links Audits by Network" )
     table( class="table-hover no-margins" )
        thead
        th
          th This Month
            th Last Month
          
        tbody
          tr
            td Awin 
            td 2000 
            td 200
          tr
            td TradeDoubler
            td 100
            td 200
        tfoot
          tr 
            th Our Monthly Allowance:
            th( colspan="2" ) 1000 links resets 23rd of the month
</template>
<script>
import gql from "graphql-tag";
import Vue from "vue";
export default Vue.extend({
  data() {

  },
})

</script>
